import { render, staticRenderFns } from "./CardTotalOriginal.vue?vue&type=template&id=080f0982&scoped=true&"
import script from "./CardTotalOriginal.vue?vue&type=script&lang=js&"
export * from "./CardTotalOriginal.vue?vue&type=script&lang=js&"
import style0 from "./CardTotalOriginal.vue?vue&type=style&index=0&id=080f0982&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080f0982",
  null
  
)

export default component.exports